import {combineReducers} from "redux";
import Root from "./root.reducer";
import Sites from "./sites.reducer";
import Controllers from "./controllers.reducer";
import Inventories from "./inventories.reducer";
import Address from "./address.reducer";
import Reports from "./reports.reducer";
import Users from "./users.reducer";
import Group from "./group.reducer";
import Customers from "./customer.reducer";
import Contacts from "./contacts.reducer";
import General from "./general.reducer";
import Alerts from "./alerts.redcucer";
import Tsdb from "./tsdb.reducer";
import DataExplorer from "./data-explorer.reducer";
import Notifications from "./notification.reducer";
import Theme from "./theme.reducer";
import AdvanceTab from "./advanceTab.reducer";
import ToolsTab from "./toolsTab.reducer";
import WebhooksReducer from "./webhooks.reducer";
import CustomFieldsReducer from "./customFields.reducer";
import CloneProfile from "./cloneProfile.reducer";
import EventRulesReducer from "./eventRule.reducer";

const reducers = combineReducers({
  general: Root,
  sites: Sites,
  controllers: Controllers,
  inventories: Inventories,
  address: Address,
  reports: Reports,
  users: Users,
  group: Group,
  customers: Customers,
  contacts: Contacts,
  generalSettings: General,
  alerts: Alerts,
  tsdb: Tsdb,
  dataExplorer: DataExplorer,
  theme: Theme,
  notifications: Notifications,
  advanceTab: AdvanceTab,
  toolsTab: ToolsTab,
  webhooks: WebhooksReducer,
  customFields: CustomFieldsReducer,
  cloneProfile: CloneProfile,
  eventRules: EventRulesReducer,
});

export default reducers;
